import { render, staticRenderFns } from "./app-settings.vue?vue&type=template&id=22120f2c&scoped=true"
import script from "./app-settings.vue?vue&type=script&lang=js"
export * from "./app-settings.vue?vue&type=script&lang=js"
import style0 from "./app-settings.vue?vue&type=style&index=0&id=22120f2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22120f2c",
  null
  
)

export default component.exports